(function (angular) {
	'use strict';

	angular.module('progressBarModule', [
		'coreModule'
	]);
})(window.angular);